'use client'
import { jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { DEFAULT_MAX_TRAVELERS } from "../constants.js";
import external_TravelerSelectionDesktop_js_default from "./TravelerSelectionDesktop.js";
import external_TravelerSelectionMobile_js_default from "./TravelerSelectionMobile.js";
import { useTravelerSelection } from "../hooks/useTravelerSelection.js";
import { InputButton } from "../../InputButton/index.js";
function TravelerSelection({ ageSelectEnabled, disclaimer, errorMessage, initialValues, isInternationalFlight, isHotel = false, isMobile = false, isTravelerSelectionDisabled = false, isWhiteLabel, lapInfantLabel, maxAdults, maxChildren, maxTravelers = DEFAULT_MAX_TRAVELERS, maxRooms, maxRoomsMessage, maxRoomsUrl, fireMaxRoomsOnClick, roomsEnabled, shouldCountLapInfant, subLabelMap, onChange, shouldAllowInternationalLapInfants, ...props }) {
    const useTravelerSelectionProps = useMemo(()=>({
            initialValues: {
                rooms: roomsEnabled ? 1 : 0,
                ...initialValues
            },
            ageSelectEnabled: !!ageSelectEnabled,
            errorMessage,
            isInternationalFlight: !!isInternationalFlight,
            isWhiteLabel,
            maxTravelers,
            shouldCountLapInfant,
            shouldAllowInternationalLapInfants
        }), [
        ageSelectEnabled,
        errorMessage,
        initialValues,
        isInternationalFlight,
        isWhiteLabel,
        maxTravelers,
        roomsEnabled,
        shouldAllowInternationalLapInfants,
        shouldCountLapInfant
    ]);
    const [isOpen, setIsOpen] = useState(false);
    const state = useTravelerSelection(useTravelerSelectionProps);
    function handleOpen(val) {
        setIsOpen(val ?? true);
        if (onChange) onChange(state);
    }
    function handleClose() {
        setIsOpen(false);
        if (onChange) onChange(state);
    }
    const TravelerSelectionProps = {
        ageSelectEnabled,
        disclaimer,
        handleClose,
        isHotel,
        lapInfantLabel,
        maxAdults,
        maxChildren,
        maxRooms,
        fireMaxRoomsOnClick,
        maxRoomsMessage,
        maxRoomsUrl,
        roomsEnabled,
        shouldCountLapInfant,
        state,
        subLabelMap,
        onChange,
        ...props
    };
    const InputTrigger = useCallback((props)=>/*#__PURE__*/ jsx("div", {
            ...props,
            className: "w-full",
            children: /*#__PURE__*/ jsx(InputButton, {
                "data-testid": "traveler-selection-input",
                iconLeft: 'person',
                label: state.label,
                size: 'lg',
                className: "w-full",
                errorMessage: state.errorMessage,
                isDisabled: isTravelerSelectionDisabled
            })
        }), [
        state.label,
        state.errorMessage,
        isTravelerSelectionDisabled
    ]);
    return isMobile ? /*#__PURE__*/ jsx(external_TravelerSelectionMobile_js_default, {
        ...TravelerSelectionProps,
        isOpen: isOpen,
        handleOpen: handleOpen,
        isDisabled: isTravelerSelectionDisabled
    }) : /*#__PURE__*/ jsx(external_TravelerSelectionDesktop_js_default, {
        ...TravelerSelectionProps,
        isOpen: isOpen,
        renderInput: InputTrigger,
        handleOpen: handleOpen
    });
}
export { TravelerSelection };
